import React from 'react';
import TestGrid from './components/TestGrid';
import useTestFetching from './hooks/useTestFetching';
import useTestActions from './hooks/useTestActions';

const TestList = () => {
  const { 
    tests, 
    loading, 
    error, 
    nextPageToken,
    isLastPage,
    isFirstPage,
    fetchNextPage,
    fetchPrevPage
  } = useTestFetching({
    topic: 'MATH',
    endpoint: 'tests'
  });

  const { handleStartTest, handlePayment } = useTestActions();

  return (
    <div className="container">
      {/* Header Section */}
      <div className="section-header">
        <h1 className="section-title">All Assessments</h1>
        <div className="section-subtitle">
          Browse and take tests across different difficulty levels
        </div>
      </div>

      <TestGrid
        tests={tests}
        onStartTest={handleStartTest}
        onPayment={handlePayment}
        variant="compact"
        loading={loading}
        error={error}
      />
      
      {/* Pagination Controls */}
      {!loading && !error && tests.length > 0 && (
        <div style={{
          width: '100%',
          paddingTop: 'var(--spacing-2xl)',
          marginTop: 'var(--spacing-2xl)',
          borderTop: '1px solid var(--border-color)'
        }}>
          <div style={{ 
            display: 'flex',
            justifyContent: 'center',
            gap: 'var(--spacing-md)'
          }}>
            <button
              onClick={fetchPrevPage}
              disabled={isFirstPage}
              className="button button-secondary"
            >
              Previous
            </button>
            <button
              onClick={fetchNextPage}
              disabled={isLastPage}
              className="button button-primary"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestList;